export function sanitizeUrl(url: string): string {
  return url
    .replace(/\/\//, '/')
    .replace(/\/$/, '')
    .replace(/\/index$/, '');
}

export type RouteToScreenMap = {
  index: string;
  useParams?: () => unknown;
  [routeName: string]: string | RouteToScreenMap | (() => unknown) | undefined;
};

export function flattenRoutes<T extends RouteToScreenMap>(routesMap: T, baseUrl = ''): T {
  const { index, useParams, ...routes } = routesMap;

  return Object.entries(routes).reduce(
    (mem, [route, value]) => {
      switch (typeof value) {
        case 'undefined':
        // fallthrough
        case 'function':
          return mem;
        case 'string':
          return { ...mem, [route]: sanitizeUrl(`${index}/${value}`) };
        default:
          return { ...mem, [route]: flattenRoutes(value, index) };
      }
    },
    { index: sanitizeUrl(`${baseUrl}/${routesMap.index}`), useParams } as T,
  );
}
